import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const LinkedInIcon = ({
  color, fillOpacity, ...props
}) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill="#767676"
      d="M11.2292 0.00537109H3.75892C1.68914 0.00537109 0 1.69451 0 3.76429V11.2464C0 13.3043 1.68914 14.9935 3.75892 14.9935H11.2411C13.3109 14.9935 15 13.3043 15 11.2345V3.76429C14.9881 1.69451 13.299 0.00537109 11.2292 0.00537109ZM4.99604 12.1386H2.85488V5.95303H4.99604V12.1386ZM3.91356 5.0014C3.3069 5.0014 2.81919 4.5137 2.81919 3.90703C2.81919 3.30037 3.3069 2.81267 3.91356 2.81267C4.52022 2.81267 5.00793 3.30037 5.00793 3.90703C4.99603 4.5137 4.50833 5.0014 3.91356 5.0014ZM12.1451 12.1386H12.1332H10.3489V9.14097C10.3489 8.41536 10.2538 7.48752 9.26646 7.48752C8.25535 7.48752 8.08882 8.27262 8.08882 9.09339V12.1386H6.30452V5.95303H7.96987V6.7857H8.01745C8.27914 6.30989 8.88581 5.94113 9.83743 5.94113C11.8002 5.94113 12.1451 7.07119 12.1451 8.74843V12.1386Z"
    />
  </svg>
);

LinkedInIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};


LinkedInIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(18, 18),
  ...helpers.getViewBoxProperty({ width: 15, height: 15 }),

};

export default LinkedInIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/linkedIn-v1.js